export default __webpack_public_path__ + "static/media/logo_tel_access.64fbbeb5.png";